type ConstructorParameters<T> = T extends new (...args: infer P) => any
  ? P
  : never

export const class_function_wrapper = <T>(klass: new (...args: any[]) => T) => {
  return (...args: ConstructorParameters<T>) => new klass(...args)
}
